import { render } from "./DrawerMessenger.vue?vue&type=template&id=4d64d74d"
import script from "./DrawerMessenger.vue?vue&type=script&lang=ts"
export * from "./DrawerMessenger.vue?vue&type=script&lang=ts"
script.render = render

export default script